import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({ name: 'weekOfYear' })
export class WeekPipe implements PipeTransform {
    transform(value: string): number {
        return moment(value).week();
    }
}
